import { type Color } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const green = {
  100: '#E5F6ED',
  200: '#CCEEDB',
  300: '#99DCB7',
  400: '#66CB93',
  500: '#33B96F',
  600: '#00A84B',
  700: '#00863C',
  800: '#00652D',
  900: '#00431E',
} satisfies Partial<Color>
